import { TableOutlined } from '@ant-design/icons'
import { ModelIconLabel, useMe } from '@salescore/client-common'
import { CORE_CONSTANT, type CoreModel, coreModelSchema } from '@salescore/core'
import { canUseOrganizationLicenseForModel } from '@salescore/features'
import { Form, Select } from 'antd'
import { Array, pipe } from 'effect'
import { t } from 'i18next'
import type { ReactElement } from 'react'
import { useRecoilValue } from 'recoil'

import { viewsContextAtom } from '../../../../recoil/view/atoms'
import { KpiFormRootNodeFormItemOptionOrder } from '../../common'

export const KpiFormRootNodeFormItem = ({
  modelName,
  setModel,
}: {
  modelName: string | undefined
  setModel: (model: CoreModel) => void
}): ReactElement => {
  const me = useMe()
  const { models } = useRecoilValue(viewsContextAtom)
  const options = pipe(
    models,
    Array.filter((x) => !x.name.endsWith(CORE_CONSTANT.SNAPSHOT_SEQUENCE_TABLE_SUFFIX)),
    // 選択済みのモデルは license が無くても残す。外すと Select が内部名を表示し、既存 KPI の設定が読めなくなる
    Array.filter((x) => x.name === modelName || canUseOrganizationLicenseForModel(me.myUser, x.name)),
    Array.sort(KpiFormRootNodeFormItemOptionOrder),
    Array.map((model) => ({
      value: model.name,
      label: (
        <span>
          {model.label}
          <span className="ml-2 text-xs text-gray-500">- {model.name}</span>
        </span>
      ),
      key: `${model.name} ${model.label}`, // 検索用
      model,
    })),
  )

  return (
    // 表示のためにForm.Itemを使うが、valueはmodelStateに基づき、formに状態やロジックは持たせない
    <Form.Item
      label={
        <div>
          <TableOutlined /> {t(`集計のベースとなるオブジェクト`)}
        </div>
      }
      data-e2e="kpi-form-root-node-form-item"
      rules={[{ required: true }]}
    >
      <Select
        showSearch
        // placeholder={"集計のベースとなるオブジェクト"}
        filterOption={(input, option) => (option?.key ?? '').toLowerCase().includes(input.toLowerCase())}
        onChange={(value) => {
          const pickedModel = models.find((x) => x.name === value)
          if (pickedModel === undefined) {
            // ありえないはず
            return
          }
          setModel(pickedModel)
        }}
        value={modelName}
        options={options}
        optionRender={(option) => {
          const model = coreModelSchema.safeParse(option.data.model)
          return model.success ? (
            <ModelIconLabel model={model.data} />
          ) : (
            <span className="whitespace-normal break-words ">{option.label}</span>
          )
        }}
      />
    </Form.Item>
  )
}
